/* @flow */

import * as Yup from 'yup'

import WebshopBannerSettings from './WebshopBannerSettings'
import WebshopBanner, {
  useWebshopGridItemBannerContentContainerStyle,
  WebshopGridItemBanner,
  WebshopGridItemBannerChildrenContainer,
} from './WebshopBanner'

import { mergeWidgetSettings } from '../shared'

type WidgetSettings = {
  height: number,
  inner_elements_position:
    | 'center'
    | 'top_left'
    | 'top_right'
    | 'bottom_left'
    | 'bottom_right',
  inner_elements_stack_mode: 'stacked' | 'side_by_side',
  inner_elements_space_between_each: number,

  link_type: 'disabled' | 'navigation_link' | 'webshop_page' | 'manual_url',
  navigation_link_id: number | null,
  webshop_page_id: number | null,
  manual_url: string,
}

export const createWebshopBannerDefaultSettings = () => {
  return {
    default_settings: ({
      height_mode: 'fixed',
      fixed_height: 600,
      viewport_percentage_height: null,
      inner_elements_position: 'center',
      inner_elements_stack_mode: 'stacked',
      inner_elements_space_between_each: 20,

      link_type: 'disabled',
      navigation_link_id: null,
      webshop_page_id: null,
      manual_url: '',
    }: WidgetSettings),

    default_style: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 0,

      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
    },

    duplicate_reset_fields: ['banner'],

    settings_validation: Yup.object().shape({
      data: Yup.object().shape({
        // banner: Yup.array().min(1).required('Upload an image or video'),
        fixed_height: Yup.number()
          .integer()
          .required('Enter the height you want in pixels')
          .typeError('Enter the height you want in pixels'),
      }),
    }),
  }
}

const widget = mergeWidgetSettings(
  {
    component: WebshopBanner,
    settings: WebshopBannerSettings,

    available_children: ['link_button', 'text'],
    label: 'Banner',
  },
  createWebshopBannerDefaultSettings()
)

export default widget

export {
  useWebshopGridItemBannerContentContainerStyle,
  WebshopGridItemBanner,
  WebshopGridItemBannerChildrenContainer,
}
